import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ClareHomeRPCMethodNames, ClareHomeRPCServiceNames, HD_ACCESS_METHODS } from "../ClareHomeRpc.constants";
import { EquatorProxyService } from "../equator-proxy";

@Injectable({
    providedIn: "root",
})
export class EquatorDevicesSecureService {
    constructor(readonly equatorProxyService: EquatorProxyService) {}

    private call(
        uuid: string,
        method: ClareHomeRPCMethodNames,
        params: any[],
        service: ClareHomeRPCServiceNames = ClareHomeRPCServiceNames.HD_ACCESS
    ) {
        return this.equatorProxyService.makeSecureClareHomeRpcRequest$(uuid, service, method, params);
    }

    public invokeDCOOperation(
        uuid: string,
        uid: string,
        deviceClass: string,
        operation: string,
        args?: { [key: string]: string | number }
    ): Observable<any> {
        return this.call(uuid, HD_ACCESS_METHODS.INVOKE_DCO_OPERATION, [uid, deviceClass, operation, args || {}]);
    }

    public getDCOProperty(uuid: string, uid: string, deviceClass: string, property: string): Observable<any> {
        return this.call(uuid, HD_ACCESS_METHODS.GET_DCO_PROPERTY, [uid, deviceClass, property]);
    }
}
